'use strict';

import UserServiceInterface from '../interfaces/iuser-service';

export default class ContentBlockHTTPService extends UserServiceInterface {
  /**
   * @param {iHttpService} http
   * @param {Object} routes
   */
  constructor(http, routes) {
    super()
    this.http = http;
    this.routes = routes;
  }
  getAllUsers() {
    return this.http.get(this.routes.getAllUsers);
  }
  getUserById() {
    return this.http.get(this.routes.getUserById);
  }
  addUser(user) {
    return this.http.post(this.routes.addUser, null, null, user);
  }
  updateUser(user) {
    return this.http.patch(this.routes.updateUser, {
      id: user.id
    }, null, user);
  }
}
